export default __webpack_public_path__ + "static/media/claro-musica.b0ac3b34.png";